// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo {
  --font-size-company: 2.5rem;
  --font-size-motto: 1.1rem;
}

.logo {
  display: grid;
  grid-template-columns: 25% 1fr;
  font-family: Gotham, Arial, Helvetica, sans-serif;
  font-size: var(--font-size-medium);
  font-weight: bold;
  text-transform: capitalize;
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
}
.logo .image-container {
  background-image: url(/images/logo-only-transparent.png);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;
}
.logo .company {
  font-size: var(--font-size-company);
  letter-spacing: -0.25rem;
  font-weight: bolder;
  color: var(--brand-color-name);
  line-height: 1;
  justify-self: self-start;
  width: max-content;
  padding-inline-end: 0.2rem;
  clip-path: polygon(9% 0, 100% 0, 100% 100%, 0 100%, 0% 31%);
}
.logo .motto {
  grid-column: 1/-1;
  color: var(--brand-color-main);
  font-weight: normal;
  font-size: var(--font-size-motto);
  letter-spacing: -0.02rem;
  margin-top: -0.6rem;
}
.logo.french .motto {
  letter-spacing: -0.14rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/logo/logo.component.scss"],"names":[],"mappings":"AAAA;EACI,2BAAA;EACA,yBAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;EACA,iDAAA;EACA,kCAAA;EACA,iBAAA;EACA,0BAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;AACJ;AACI;EACI,wDAAA;EACA,2BAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,WAAA;AACR;AAEI;EACI,mCAAA;EACA,wBAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;EACA,wBAAA;EACA,kBAAA;EACA,0BAAA;EACA,2DAAA;AAAR;AAGI;EACI,iBAAA;EACA,8BAAA;EACA,mBAAA;EACA,iCAAA;EACA,wBAAA;EACA,mBAAA;AADR;AAII;EACI,wBAAA;AAFR","sourcesContent":[".logo{\n    --font-size-company: 2.5rem;\n    --font-size-motto: 1.1rem;\n}\n\n.logo {\n    display: grid;\n    grid-template-columns: 25% 1fr;\n    font-family: Gotham, Arial, Helvetica, sans-serif;\n    font-size: var(--font-size-medium);\n    font-weight: bold;\n    text-transform: capitalize;\n    align-items: center;\n    user-select: none;\n\n    .image-container{\n        background-image: url(/images/logo-only-transparent.png);\n        background-position: center;\n        background-size: contain;\n        background-repeat: no-repeat;\n        height: 100%;\n        width: 100%;\n    }\n\n    .company {\n        font-size: var(--font-size-company);\n        letter-spacing: -0.25rem;\n        font-weight: bolder;\n        color: var(--brand-color-name);\n        line-height: 1;\n        justify-self: self-start;\n        width: max-content;\n        padding-inline-end: 0.2rem;\n        clip-path: polygon(9% 0, 100% 0, 100% 100%, 0 100%, 0% 31%);\n    }\n\n    .motto {\n        grid-column: 1 / -1;\n        color: var(--brand-color-main);\n        font-weight: normal;\n        font-size: var(--font-size-motto);\n        letter-spacing: -0.02rem;\n        margin-top: -0.6rem;\n    }\n\n    &.french .motto {\n        letter-spacing: -0.14rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
